var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconTwitter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "21.64px",
    height: "17.79px",
    viewBox: "0 0 21.64 17.79",
    enableBackground: "new 0 0 21.64 17.79",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    y: 0,
    width: 21.64,
    height: 17.79
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    d: "M21.64,2.107c-0.811,0.361-1.67,0.599-2.551,0.705c0.931-0.562,1.624-1.444,1.95-2.481 c-0.871,0.52-1.825,0.887-2.819,1.085C17.384,0.513,16.21-0.001,14.98,0c-2.466,0.014-4.453,2.023-4.441,4.488 c-0.001,0.344,0.04,0.688,0.121,1.023C7.08,5.325,3.75,3.618,1.51,0.82c-1.177,2.051-0.581,4.662,1.37,6 C2.175,6.795,1.486,6.603,0.869,6.259v0.057c-0.008,2.126,1.479,3.964,3.561,4.4c-0.381,0.107-0.775,0.161-1.17,0.161 c-0.279,0.001-0.557-0.026-0.83-0.082c0.565,1.821,2.232,3.077,4.14,3.118C4.714,15.382,2.349,16.05,0,15.77 c2.026,1.318,4.392,2.02,6.81,2.02c8.16,0,12.63-6.846,12.63-12.776c0-0.2-0.01-0.388-0.021-0.58 C20.291,3.795,21.043,3.008,21.64,2.107"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTwitter);
export default __webpack_public_path__ + "static/media/icon-twitter.cde97da1f53aa939f06eae7412d76e32.svg";
export { ForwardRef as ReactComponent };